<template>
  <div>
    <div style="margin-top:10px">
      <!-- download="" -->
      <el-button type="primary"  ><a :href="file0" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">CAC2025参展商指南</a></el-button>
      <el-button type="primary"  ><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" >CAC2025整合营销手册</a></el-button>
      <el-button type="primary"  ><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">FSHOW2025宣传方案</a></el-button>
      <el-button type="primary"  ><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">邀请函文件</a></el-button>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import moment from 'moment'
import firstBanner from '@/assets/firstBanner.jpg'
import tools from '@/utils/tools';
moment.locale('zh-cn')
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      file0:'./CAC2025参展商指南－中文版.pdf',
      file1:'./CAC2025整合营销手册.pdf',
      file2:'./FSHOW2025宣传方案.pdf',
      file3:'./Invitation Letter Documents.zip',
    }
  },
  methods: {
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>

@media screen and (max-width:540px){

}
</style>
